import {SMALL} from './BreakPoints.js'
/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {

    isMobile : {
        default : false,
        [SMALL] : true
    },

    spacingInset_shorthand2 : {
        default : "none large",
        [SMALL] : "none medium",
    },
 
    spacingInset_shorthand4 : {
        default : "small large small large",
        [SMALL] : "small medium small medium",
    }
}


// WEBPACK FOOTER //
// ./src/components/common/constant/ResponsiveProps.js